export type Testimonial = {
  name: string
  role: string
  city: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Marta R.',
    role: 'Hija y cuidadora',
    city: 'Buenos Aires',
    quote:
      'Mi mamá tiene 78 años y empezaba con olvidos frecuentes. No sabía cómo ayudarla sin que se sintiera incómoda o tratada como una nena. Con el Cuaderno Mente Despierta ahora compartimos actividades todas las tardes.',
  },
  {
    name: 'Ricardo G.',
    role: 'Cuidador profesional',
    city: 'Córdoba',
    quote:
      'El Módulo VIP me ayudó muchísimo. Tengo actividades organizadas por niveles para cada persona. Las familias valoran tener un plan más claro y yo dejé de improvisar.',
  },
  {
    name: 'Laura F.',
    role: 'Hija y cuidadora',
    city: 'La Plata',
    quote:
      'La Bitácora ordenó todo lo que antes eran papeles sueltos. Ahora llevo mejor registro de presión, glucemia y medicación para la consulta de mi papá.',
  },
  {
    name: 'Javier R.',
    role: 'Nieto y cuidador',
    city: 'Tucumán',
    quote:
      'Nunca imaginé que iba a poder compartir ejercicios con mi abuelo. Hacemos rutinas en silla y se volvió un momento lindo.',
  },
  {
    name: 'Carolina M.',
    role: 'Cuidadora principal',
    city: 'Santa Fe',
    quote:
      'La Guía del Cuidador me ayudó a darme cuenta de que estaba haciendo todo sola. El mapa familiar me sirvió para repartir responsabilidades con mis hermanos.',
  },
]
